import { useMemo } from 'react';

import { CodeLanguageType } from '@/components/Code/types';

import { formatContent } from './formatContent';

// Helper component for full mode display with memoization
export const FullModeCell = ({
  value,
  language,
  maxLength,
}: {
  value: unknown;
  language: CodeLanguageType;
  maxLength: number;
}) => {
  const content = useMemo(
    () => formatContent(value, language, maxLength),
    [value, language, maxLength]
  );

  return (
    <div className="max-w-[350px] overflow-hidden whitespace-pre-wrap p-2 font-mono text-xs">
      {content}
    </div>
  );
};

// Helper component for compact mode display with memoization
export const CompactModeCell = ({ value }: { value: unknown }) => {
  const content = useMemo(() => {
    return typeof value === 'string' ? value : JSON.stringify(value);
  }, [value]);

  return content;
};
